export const addBox = (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.0146 7.99951L25.5 8.85693V18.8569L25.3486 19.1235H23.5V10.6226L15.5 15.4224V23.1235H19.333L15.0146 25.7144H13.9854L3.98535 19.7144L3.5 18.8569V8.85693L3.98535 7.99951L13.9854 1.99951H15.0146L25.0146 7.99951ZM5.5 18.2905L13.5 23.0903V15.4224L5.5 10.6226V18.2905ZM6.44336 8.85693L14.5 13.6899L17.5557 11.856L9.49902 7.02295L6.44336 8.85693ZM11.4434 5.85596L19.499 10.6899L22.5557 8.85693L14.5 4.02295L11.4434 5.85596Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 20.1235H26.5V22.1235H22.5V25.9995H20.5V22.1235H16.5V20.1235H20.5V16.2476H22.5V20.1235Z"
      fill="currentColor"
    />
  </>
);
